<template>
  <v-menu
    v-if="filteredStores && filteredStores.length"
    content-class="store-list"
    open-on-hover
    bottom
    offset-y
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="available-button"
        color="rgba(0,0,0,.87)"
        text
        dark
      >
        <b>
          {{ storeName }}
        </b>

        <svg
          width="10"
          height="6"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.13579 0.349188L0.33012 5.49934C-0.11004 5.97105 -0.11004 6.74416 0.33012 7.21587L0.731177 7.64568C1.17084 8.11739 1.89224 8.11739 2.3324 7.64568L6.00006 3.71618L9.66723 7.64622C10.1074 8.11793 10.8288 8.11793 11.2684 7.64622L11.6695 7.21641C12.1102 6.7447 12.1102 5.97158 11.6695 5.49987L6.86334 0.349725C6.62722 0.0961395 6.31038 -0.0166845 5.99956 0.00211961C5.68924 -0.0172214 5.37241 0.0956026 5.13579 0.349188Z"
            fill="#A9A9A9"
          />
        </svg>

        <template #loader>
          <span class="custom-loader">
            <v-icon light>
              mdi-cached
            </v-icon>
          </span>
        </template>
      </v-btn>
    </template>

    <v-list
      v-if="filteredStores && filteredStores.length"
      dense
    >
      <v-list-item
        v-for="(store, index) in filteredStores"
        :key="index"
      >
        <v-list-item-title @click="setStore(store)">
          {{ store.name }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <b v-else style="white-space: nowrap; font-size: 10px">
    {{ storeName }}
  </b>
</template>

<script>
export default {
  name: "StoreList",
  props: {
    stores: {
      type: [Array, String],
      default: () => []
    },
    marketArea: {
      type: Array,
      required: true
    },
    storeName: {
      type: String,
      default: "SPB"
    },
    item: {
      type: [Object]
    }
  },
  computed: {
    filteredStores() {
      return this.getFilteredStores(this.stores);
    }
  },
  emits: ["update:article"],
  methods: {
    getFilteredStores(array) {
      if (!array.length) return [{ name: "SPB", store_id: 3 }];

      let res = array
        .filter(ma => this.marketArea.includes(ma.name))
        .reduce((stores, ma) => {
          ma.stores.forEach(s => stores.push(s));
          return stores;
        }, []);
      console.log(res);
      if (!res.filter(store => parseInt(store.store_id) === 3).length) {
        res.unshift({ name: "SPB", store_id: 3 });
      }

      return res;
    },
    setStore(store) {
      this.$emit("update:article", {
        property: "storeName",
        value: store.name
      });
      this.$emit("update:article", {
        property: "store_id",
        value: store.store_id
      });
    }
  }
};
</script>

<style lang="scss">
@import "StoreList";
</style>
